import { Grid } from '@material-ui/core';
import React from 'react';
import { IOpportunityItemSummaryReportFilter } from '../../../../../state/report';
import { SearchDateField, SearchField } from '../../../../components';
import {
  FilterContainer,
  IFilterContainerConfigProps,
} from '../../../../components/FilterContainer';

const OpportunityItemSummaryReportFilterComponent: React.FC<
  IFilterContainerConfigProps<IOpportunityItemSummaryReportFilter>
> = (props) => {
  return (
    <FilterContainer
      {...props}
      render={(filterProps) => {
        const { localFilter, handleChangeFilter, handleChangeDateFilter } = filterProps;
        return (
          <Grid container spacing={1}>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Company"
                filterKey="Opportunity.Company.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Assignment"
                filterKey="Opportunity.AssignmentNumber.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Project"
                filterKey="Opportunity.SmProject.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Project Owner"
                filterKey="Opportunity.SmProject.Owner.FullName.Contains"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Program"
                filterKey="Block.Program.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Brand"
                filterKey="Block.Brand.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Item"
                filterKey="Block.Item.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Block No"
                filterKey="Block.BlockNo.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>

            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Sales"
                filterKey="Opportunity.Responsibility.ResponsibilitySalesTeamMember.SalesTeamMember.User.FullNameWithUserName.Contains"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="CS"
                filterKey="Opportunity.Responsibility.ResponsibilityWorkingTeamMember.SmWorkingTeamMember.User.FullNameWithUserName.Contains"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDateField
                showTodayButton={true}
                fullWidth={true}
                label="Start Created Date"
                onChange={handleChangeDateFilter}
                filters={localFilter}
                filterKey={'Opportunity.CreatedAt.GreaterThanOrEqual'}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDateField
                showTodayButton={true}
                fullWidth={true}
                label="End Created Date"
                onChange={handleChangeDateFilter}
                filters={localFilter}
                filterKey={'Opportunity.CreatedAt.LessThanOrEqual'}
              />
            </Grid>
          </Grid>
        );
      }}
    />
  );
};

export default OpportunityItemSummaryReportFilterComponent;
